import {useEffect, useMemo} from "react";
import {matchPath, useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {routes} from "../../config/route-config.tsx";
import {setIsTreatment} from "../../redux/slices/detailsSlice";

function RouteTreatmentSync() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const currentIsTreatment = useSelector((state) => state.details.isTreatment);

  const routeDerivedIsTreatment = useMemo(() => {
    const treatmentPaths = [
      ...routes.existingTreatment,
      ...routes.newTreatment,
    ];
    return treatmentPaths.some((p) => matchPath(p, pathname));
  }, [pathname]);

  useEffect(() => {
    if (routeDerivedIsTreatment !== currentIsTreatment) {
      dispatch(setIsTreatment(routeDerivedIsTreatment));
    }
  }, [routeDerivedIsTreatment]);

  return null;
}

export default RouteTreatmentSync;